import React from "react";
import MyProfileConatiner from "containers/Profile";


const MyProfile = () => {
  return (
    <>
    <MyProfileConatiner />
    </>
    
  );
};

export default MyProfile;
